$('.js-openModalButton').on('click', function(e) {
    $(`.js-modal[data-modal-id=${$(this).data('modal-src')}]`).addClass('popup--visible')
    $('html').addClass('html-hidden-popup')
})

$('.js-closeModalButton').on('click', function(e) {
    $(`.js-modal`).removeClass('popup--visible')
	$('html').removeClass('html-hidden-popup')
})

$(document).ready(function() {
    $('.popup .application-form-content.offset-lg-3').removeClass('offset-lg-3')
})